import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './ModalBody.module.css';

const ModalBody = (props) => {
  const { children, className } = props;
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      {children}
    </div>
  )
};

ModalBody.defaultProps = {
  className: null,
};

ModalBody.propTypes = {
  className: string,
};

export default ModalBody;
